// removed by extract-text-webpack-plugin
module.exports = {"WidgetTooltip":"_299-ayuvPr","WidgetNodeTooltip":"_1lNFqyEX2e","WidgetNode":"_1QtQp8-Yx0","focused":"_1QJ4P0T1Sv","title":"QZB5ZWoilP","description":"_27VTr_8D0l","SubscribeNode":"_2y7BxAAHRh","emailInput":"PnI-bg3MjL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetSlatePlugin/WidgetSlatePlugin.scss
// module id = 374
// module chunks = 0